export interface WorkingHoursProps {
  day: string;
  hours: string;
}

export function WorkingHours(props: WorkingHoursProps) {
  const { day, hours } = props;
  return (
    <div className="grid grid-cols-[44px_1fr]">
      <span className="text-base uppercase text-gray-extra-dark leading-[19.2px]">
        {day}:
      </span>
      <span className="text-base capitalize text-gray-extra-dark text-opacity-80 leading-[19.2px]">
        {hours}
      </span>
    </div>
  );
}

export default WorkingHours;
